"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderColor = exports.renderUnderline = exports.renderHeading = exports.normalizeHeaderLevel = exports.normalizeHeadingClassName = exports.renderBlockquote = exports.renderCodeBlock = exports.renderListItem = exports.buildRenderers = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const markdown_module_css_1 = __importDefault(require("@vtblife/react-markdown-styles/dist/markdown.module.css"));
const react_markdown_utils_1 = require("@vtblife/react-markdown-utils");
const react_syntax_highlighter_1 = __importDefault(require("react-syntax-highlighter"));
const hljs_1 = require("react-syntax-highlighter/dist/cjs/styles/hljs");
const image_1 = require("./renderers/image");
const table_1 = require("./renderers/table");
const correct_link_1 = require("./renderers/correct-link");
__exportStar(require("./renderers/markdown-heading"), exports);
function buildRenderers({ startHeader, styles, classNames, linkFrom, breakpoints }) {
    const createHeading = headingProps => {
        return exports.renderHeading(Object.assign({ startHeader,
            breakpoints,
            styles, className: classNames === null || classNames === void 0 ? void 0 : classNames.headers, headerStyles: styles }, headingProps));
    };
    return {
        heading: props => createHeading(props),
        h1: props => createHeading(Object.assign(Object.assign({}, props), { level: 1 })),
        h2: props => createHeading(Object.assign(Object.assign({}, props), { level: 2 })),
        h3: props => createHeading(Object.assign(Object.assign({}, props), { level: 3 })),
        h4: props => createHeading(Object.assign(Object.assign({}, props), { level: 4 })),
        h5: props => createHeading(Object.assign(Object.assign({}, props), { level: 5 })),
        paragraph: renderParagraph,
        a: props => react_1.default.createElement(correct_link_1.CorrectLink, Object.assign({}, props, { linkFrom: linkFrom })),
        link: props => react_1.default.createElement(correct_link_1.CorrectLink, Object.assign({}, props, { linkFrom: linkFrom })),
        underline: exports.renderUnderline,
        code: exports.renderCodeBlock,
        sub: 'sub',
        sup: 'sup',
        colorText: exports.renderColor,
        image: image_1.image,
        img: image_1.image,
        table: table_1.table,
        list: props => {
            const Tag = props.ordered ? 'ol' : 'ul';
            return react_1.default.createElement(Tag, Object.assign({}, props), props.children);
        },
        listItem: exports.renderListItem,
        li: exports.renderListItem,
    };
}
exports.buildRenderers = buildRenderers;
exports.renderListItem = (props) => {
    return (react_1.default.createElement("li", Object.assign({}, props),
        react_1.default.createElement("span", null, props.children)));
};
exports.renderCodeBlock = ({ value }) => {
    return (react_1.default.createElement(react_syntax_highlighter_1.default, { language: "javascript", style: hljs_1.docco }, value));
};
exports.renderBlockquote = (value) => {
    return (react_1.default.createElement("blockquote", null,
        react_1.default.createElement("p", null, value)));
};
exports.normalizeHeadingClassName = ({ sharps, styles = markdown_module_css_1.default, breakpoints, }) => {
    var _a;
    const breakpointsClassNames = react_markdown_utils_1.getBreakpointsClassNames({
        breakpoints,
        mappers: {
            minimalHeadingStyleLevel: minimalStyleLevel => {
                const classIndex = Math.min(sharps + minimalStyleLevel - 2, 4);
                return [`h${classIndex + 1}`];
            },
        },
    });
    return (_a = breakpointsClassNames.minimalHeadingStyleLevel) === null || _a === void 0 ? void 0 : _a.map(className => styles[className]).join(' ');
};
exports.normalizeHeaderLevel = (sharps, startHeader) => {
    return Math.min(sharps + startHeader - 1, 6);
};
function breakChildren(children) {
    return react_1.default.Children.map(children, item => {
        if (!react_1.default.isValidElement(item)) {
            return item;
        }
        const { value } = item.props;
        if (typeof value === 'string') {
            const parts = value.split(/<br\s*\/?>/);
            return parts.reduce((acc, line, index) => {
                const symbolIndex = line.indexOf('>');
                if (symbolIndex > -1) {
                    acc.push(react_1.default.createElement(react_1.default.Fragment, { key: index },
                        value.substring(0, symbolIndex),
                        exports.renderBlockquote(line.substring(symbolIndex + 1))));
                }
                else {
                    acc.push(line);
                }
                if (index < parts.length - 1) {
                    acc.push(react_1.default.createElement("br", { key: `br-${index}` }));
                }
                return acc;
            }, []);
        }
        return item;
    });
}
function renderParagraph(_a) {
    var { children } = _a, rest = __rest(_a, ["children"]);
    let className = '';
    react_1.default.Children.map(children, child => {
        if (react_1.default.isValidElement(child) && child.type === exports.renderUnderline) {
            className = markdown_module_css_1.default.removePaddingBottom;
        }
    });
    return (react_1.default.createElement("p", Object.assign({}, (className && { className: className }), rest), breakChildren(children)));
}
exports.renderHeading = ({ level, children, startHeader, breakpoints, headerStyles, className }) => {
    let Tag = startHeader;
    if (typeof startHeader === 'number' || startHeader === 'auto') {
        const tagLevel = exports.normalizeHeaderLevel(level, startHeader === 'auto' ? 0 : startHeader);
        Tag = `h${tagLevel}`;
    }
    else if (['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(startHeader)) {
        const tagLevel = Math.min(+startHeader[1] + (level - 1), 6);
        Tag = `h${tagLevel}`;
    }
    return (react_1.default.createElement(Tag, { className: classnames_1.default(exports.normalizeHeadingClassName({ sharps: level, breakpoints, styles: headerStyles }), className) }, breakChildren(children)));
};
exports.renderUnderline = ({ children }) => {
    return react_1.default.createElement("span", { className: markdown_module_css_1.default.underline }, children);
};
exports.renderColor = ({ children, data: { hName, hProperties }, }) => {
    const color = typeof (hProperties === null || hProperties === void 0 ? void 0 : hProperties.style) === 'string' ? hProperties.style.replace('color: ', '') : '#DDDDDD';
    const CustomTag = `${hName}`;
    return (react_1.default.createElement(CustomTag, { style: { color } }, react_1.default.Children.map(children, child => {
        if (react_1.default.isValidElement(child)) {
            return react_1.default.cloneElement(child, { style: { color } });
        }
        return child;
    })));
};
//# sourceMappingURL=renderers.js.map